import React, { useState, useEffect } from 'react'
import Loading from '../Common/Loading'
import Unauthorized from './Unauthorized'

const SSOSecured = ({ client, claim, force, children }) => {
  const [authorized, setAuthorized] = useState(null)
  useEffect(() => {
    client
      .checkClaim(claim, !!force)
      .then((authorization) => setAuthorized(authorization))
      .catch(() => setAuthorized(false))
  }, [claim, client, force])

  if (authorized === null) return <Loading />
  return authorized ? (
    <>{children}</>
  ) : (
    <div className="page-body">
      <Unauthorized />
    </div>
  )
}

export default SSOSecured
